/**
 * Asynchronously loads the component for ReceiptBooking
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
